import Vue from 'vue';
import Axios from 'axios';
import qs from 'qs';
import { Message } from 'element-ui';
import { defaultTimeout, defaultDataType, urlencodedDataType } from './ajax.config';
import Store from '@/store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
NProgress.configure({ showSpinner: false, minimum: 0.3, trickleRate: 0.08});

// 接口地址
Axios.defaults.baseURL = process.env.VUE_APP_SERVER;
// 超时时间
Axios.defaults.timeout = defaultTimeout;
// 默认数据类型
Axios.defaults.headers['Content-Type'] = defaultDataType;
//解决每次请求sessionId不一致的问题
Axios.defaults.withCredentials = true;

const service = Axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_SERVER,
  // 超时
  timeout: 10000,
  withCredentials: true,
});

/**
 * 请求体拦截器
 */
service.interceptors.request.use(
  (config) => {
    NProgress.start();
    if (!/user\/(login|register|updatePassword)$/.test(config.url)) { //排除登录
      const userInfo = Store.state.userInfo;
      if (userInfo) {
          config.headers.token = userInfo.token;
      }
      if (userInfo && (!userInfo.requests || userInfo.requests.length<1)){
        Store.commit('loginOut');
        return ;
      }
      if (config.dataType) { // 手动设置请求类型
        let requestType = '';
        switch (config.dataType.toLowerCase()) {
          case 'json': requestType = defaultDataType; break;// json
          case 'form': requestType = urlencodedDataType; break;// form
          default: break;
        }
        config.headers['Content-Type'] = requestType;
      }
      if (config.method.toLowerCase() === 'post'
          && config.headers['Content-Type'] === urlencodedDataType) {
        config.data = qs.stringify(config.data);
      }
    }
    return config;
  },
  (err) => {
    NProgress.done();
    Message.error({ showClose: true, message: err || '发起请求出错' });
    throw new Error(err || '发起请求出错');
  },
);

/**
 * 响应体拦截器
 */
service.interceptors.response.use(
  (res) => {
    NProgress.done();
    const data = res.data;
    const success = data.success;
    if (!success) {
      const code = data.code;
      if (code === '4009') {
        // if(Store.state.userInfo){
        //   Message.error({ showClose: true, message: '登录信息已过期或无效, 请重新登录 !' });
        // }
        // Store.commit('loginOut','登录信息已过期或无效, 请重新登录 !');
        if(Store.state.userInfo){
          const oldToken = Store.state.userInfo.token;
          Store.commit('refreshUser');
          if (Store.state.userInfo){
            const newToken = Store.state.userInfo.token;
            if (newToken && oldToken != newToken){
              location.reload();
              return ;
            }
          }
          Message.error({ showClose: true, message: '登录信息已过期或无效, 请重新登录 !' });
        }
        Store.commit('loginOut');
      } else {
        Message.closeAll();
        Message.error({ showClose: true, message: data.message || '发起请求出错 !' });
      }
    }
    return data;
  },
  (err) => {
    NProgress.done();

    if (err.response) {
      const path = err.response.data.path;
      if (path == '/file/admin/getVideoPlayAuth') {
        Message.error({ showClose: false, message: '视频正在加密转码中，请稍后播放!' });
        return;
      }
      if (err.response.status === 401) { //token过期或无效
        if(Store.state.userInfo){
          const oldToken = Store.state.userInfo.token;
          Store.commit('refreshUser');
          if (Store.state.userInfo){
            const newToken = Store.state.userInfo.token;
            if (newToken && oldToken != newToken){
              location.reload();
              return ;
            }
          }
          Message.error({ showClose: true, message: '登录信息已过期或无效, 请重新登录 !' });
        }
        Store.commit('loginOut');
      } else if (err.response.status === 406) { //无请求该接口权限
        Message.closeAll();
        Message.error({ showClose: true, message: '抱歉, 您没有此操作的权限 !' });
      } else {
        Message.error({ showClose: true, message: err.response || '服务器错误' });
      }
    } else if (err.request) {
      Message.closeAll();
      Message.error({ showClose: true, message: '网络环境太差，请稍后再试' });
    } else {
      Message.error({ showClose: true, message: err.response });
    }
    throw new Error(JSON.stringify(err));
  },
);

// 将Axios绑定到Vue
Vue.$http = service;
Vue.prototype.$http = service;
export default service

